// Shipments mutations
/* eslint-disable */
import types from '../../types';
import date from '../../../mixins/date'
import _ from 'lodash';
import {CLEAR_CONSOLIDATION_SHIPMENTS} from "@/store/types/api";
import {
  STORE_OPTIONS_FOR_SELECTS_PREFERENCES,
  STORE_OPTIONS_FOR_WAYBILL_PRINTERS
} from "../../types/api";

export default {
  [types.STORE_SHIPMENTS]: (state, payload) => {
    state.items = [...state.items, ...payload.items];
    state.count = payload.count;
    state.entity = payload.entity;
    state.ids_of_all_records = payload.ids_of_all_records;
  },
  [types.RESET_STORE_SHIPMENTS]: (state, payload) => {
    state.items = payload.items;
    state.count = payload.count;
    state.entity = payload.entity;
    state.ids_of_all_records = payload.ids_of_all_records;
  },
  [types.STORE_SHIPMENT]: (state, payload) => {
    state.singleShipment = payload;
  },
  [types.CLEAR_SHIPMENT]: (state) => {
    state.singleShipment = null;
  },
  [types.CLEAR_SHIPMENTS]: (state) => {
    state.items = [];
    state.count = 0;
    state.entity = {};
    state.ids_of_all_records = [];
  },
  [types.STORE_SHIPPERS]: (state, payload) => {
    state.shippers = payload;
  },
  [types.STORE_PALLETE_TYPES]: (state, payload) => {
    state.palleteTypes = payload;
  },
  [types.STORE_PARCEL_TYPES]: (state, payload) => {
    state.parcelTypes = payload;
  },
  [types.CLEAR_PARCEL_TYPES]: (state) => {
    state.parcelTypes = null;
  },
  [types.STORE_ADDITIONAL_FILE_TYPES]: (state, payload) => {
    state.additionalFileTypes = payload;
  },
  [types.STORE_OPTIONS_FOR_WAYBILL_PRINTERS]: (state, payload) => {
    state.waybillPrinters = payload;
  },
  [types.STORE_DANGEROUS_GOODS]: (state, payload) => {
    state.dangerousGoodsOptions = payload.dangerous_goods;
    state.dangerousGoodsServices = payload.services;
    state.dangerousGoodsTypes = payload.dangerous_goods_types;
    state.dangerousGoodsPackingTypes = payload.packing_types;
  },
  [types.STORE_UN_CODES]: (state, payload) => {
    state.unCodes = payload.un_codes;
  },
  [types.STORE_HAZARDS]: (state, payload) => {
    state.hazards = payload.hazard_classes;
  },
  [types.STORE_BOOKING_SYSTEM]: (state, payload) => {
    state.systems = payload;
  },
  // DRAFTS
  [types.STORE_DRAFT_SHIPMENTS]: (state, payload) => {
    state.drafts.items = [...state.drafts.items, ...payload.items];
    state.drafts.count = payload.count;
    state.drafts.entity = payload.entity;
    state.drafts.items.map((item) => {
      item.created_at = date.methods.formatDate(item.created_at, 'DD.MM.YYYY - HH:mm');
      return item;
    })
  },
  [types.RESET_DRAFT_SHIPMENTS]: (state, payload) => {
    state.drafts.items = payload.items;
    state.drafts.count = payload.count;
    state.drafts.entity = payload.entity;
    state.drafts.items.map((item) => {
      item.created_at = date.methods.formatDate(item.created_at, 'DD.MM.YYYY - HH:mm');
      return item;
    })
  },
  [types.CLEAR_DRAFT_SHIPMENTS]: (state) => {
    state.drafts.items = [];
    state.drafts.count = 0;
    state.drafts.entity = {};
  },
  // UNAPPROVED
  [types.STORE_UNAPPROVED_SHIPMENTS]: (state, payload) => {
    state.unapproved.items = [...state.unapproved.items, ...payload.items];
    state.unapproved.count = payload.count;
    state.unapproved.entity = payload.entity;
    state.unapproved.items.map((item) => {
      item.created_at = date.methods.formatDate(item.created_at, 'DD.MM.YYYY - HH:mm');
      return item;
    })
  },
  [types.RESET_UNAPPROVED_SHIPMENTS]: (state, payload) => {
    state.unapproved.items = payload.items;
    state.unapproved.count = payload.count;
    state.unapproved.entity = payload.entity;
    state.unapproved.items.map((item) => {
      item.created_at = date.methods.formatDate(item.created_at, 'DD.MM.YYYY - HH:mm');
      return item;
    })
  },
  [types.CLEAR_UNAPPROVED_SHIPMENTS]: (state) => {
    state.unapproved.items = [];
    state.unapproved.count = 0;
    state.unapproved.entity = {};
  },
  // END OF DAY
  [types.STORE_SHIPMENTS_EOD]: (state, payload) => {
    state.endOfDayList = payload;
  },
  [types.STORE_SINGLE_EOD_SHIPMENTS]: (state, payload) => {
    state.eodShipments = payload;
  },
  [types.STORE_SINGLE_EOD]: (state, payload) => {
    state.endOfDay = payload;
  },
  [types.CLEAR_EOD_SINGLE]: (state) => {
    state.endOfDay = null;
  },
  [types.CLEAR_SINGLE_EOD_SHIPMENTS]: (state) => {
    state.eodShipments = {
      items: [],
      entity: [],
      count: '',
    };
  },
  // CONSOLIDATIONS
  [types.STORE_CONSOLIDATIONS]: (state, payload) => {
    state.consolidationsList = payload;
  },
  [types.STORE_CONSOLIDATION_SHIPMENTS]: (state, payload) => {
    state.consolidationShipments = payload;
  },
  [types.STORE_SINGLE_CONSOLIDATION]: (state, payload) => {
    state.consolidation = payload;
  },
  [types.CLEAR_SINGLE_CONSOLIDATION]: (state) => {
    state.consolidation = {
      consolidation: null,
      waybill: null,
      barcode: null,
      cons_email_status: null,
      cons_product_types: null
    };
  },
  [types.CLEAR_CONSOLIDATION_SHIPMENTS]: (state) => {
    state.consolidationShipments = {
      items: [],
      entity: [],
      count: '',
    };
  },
  // EDITING SHIPMENTS ACTIONS
  [types.SET_EDITING_SHIPMENT]: (state, payload) => {
    //Set clean shipment state
    state.cleanShipmentCompareTemplate = _.cloneDeep(state.shipmentCompareTemplate);
    state.shipmentCompareTemplate.isReturn = payload.hasOwnProperty('is_return') ? payload.is_return : false;
    state.shipmentCompareTemplate.shipmentType = payload.shipmentType;
    state.shipmentCompareTemplate.draftShippmentId = payload.id;
    state.shipmentCompareTemplate.shippingAgentName = payload.shipping_agent_name
    if (payload.hasOwnProperty('error_statuses')) {
      state.shipmentCompareTemplate.errorStatuses = payload.error_statuses;
    }
    if (payload.hasOwnProperty('inverted')) {
      state.shipmentCompareTemplate.inverted = true;
    }
    state.shipmentEditMode = true;

    // Set date
    state.shipmentCompareTemplate.shippingDate = payload.ship_date || '';

    // SET SENDER
    if(payload.hasOwnProperty('inverted')) {
      state.shipmentCompareTemplate.foreignShipper = true;
      state.shipmentCompareTemplate.shipper = null;
      state.shipmentCompareTemplate.fromAddress = {
        address_1: payload.customer_address_1 || '',
        address_2: payload.customer_address_2 || '',
        country_id: payload.customer_country_id || '',
        post_code: payload.customer_post_code || '',
        city: payload.customer_city || '',
        state: payload.customer_state || '',
      };
      state.shipmentCompareTemplate.fromData = {
        reference: payload.receiver_reference || '',
        company: payload.customer_company_name || '',
        attention: payload.customer_name || '',
        email: payload.customer_email || '',
        vat: payload.customer_vat || '',
        phone: {
          number: payload.customer_phone || '',
          country: '',
        },
      };
      // SET CUSTOMER
      state.shipmentCompareTemplate.toAddress = {
        address_1: payload.sender_address_1 || '',
        address_2: payload.sender_address_2 || '',
        country_id: payload.sender_country_id || '',
        post_code: payload.sender_post_code || '',
        city: payload.sender_city || '',
        state: payload.sender_state || '',
      };
      state.shipmentCompareTemplate.toData = {
        reference: payload.sender_reference || '',
        company: payload.sender_company_name || '',
        shipToPrivateResident: payload.sender_company_name ? false : true,
        attention: payload.sender_name || '',
        email: payload.sender_email || '',
        vat: payload.sender_vat || '',
        phone: {
          number: payload.sender_phone || '',
          country: '',
        },
      };
    } else {
      // Set shipper
      //If sender id exist than it is not foreign shipper
      state.shipmentCompareTemplate.foreignShipper = payload.sender_id ? false : true;
      state.shipmentCompareTemplate.shipper = payload.sender_id == 0 ? null : payload.sender_id;
      state.shipmentCompareTemplate.fromAddress = {
        address_1: payload.sender_address_1 || '',
        address_2: payload.sender_address_2 || '',
        country_id: payload.sender_country_id || '',
        post_code: payload.sender_post_code || '',
        city: payload.sender_city || '',
        state: payload.sender_state || '',
      };
      state.shipmentCompareTemplate.fromData = {
        reference: payload.sender_reference || '',
        company: payload.sender_company_name || '',
        attention: payload.sender_name || '',
        email: payload.sender_email || '',
        vat: payload.sender_vat || '',
        phone: {
          number: payload.sender_phone || '',
          country: '',
        },
      };
      // SET CUSTOMER
      state.shipmentCompareTemplate.toAddress = {
        address_1: payload.customer_address_1 || '',
        address_2: payload.customer_address_2 || '',
        country_id: payload.customer_country_id || '',
        post_code: payload.customer_post_code || '',
        city: payload.customer_city || '',
        state: payload.customer_state || '',
      };
      state.shipmentCompareTemplate.toData = {
        reference: payload.receiver_reference || '',
        company: payload.customer_company_name || '',
        shipToPrivateResident: payload.customer_company_name ? false : true,
        attention: payload.customer_name || '',
        email: payload.customer_email || '',
        vat: payload.customer_vat || '',
        phone: {
          number: payload.customer_phone || '',
          country: '',
        },
      };
    }

    let groupList = [];
    const shipPackages = [];
    const payloadPackages = payload.packages;
    payloadPackages.forEach((pack) => {
      if (groupList.includes(pack.group)) return;
      const shipmentPackageGroup = payload.package_groups.filter((g) => g.id == pack.shipment_package_group_id)[0];
      const dangerousService = shipmentPackageGroup ? shipmentPackageGroup.dangerous_goods : [];

      const dangerousGoodsArray = [];
      dangerousService.forEach((service) => {
          dangerousGoodsArray.push({
            feeWrapperId: service.fee_wrapper_id.toString(),
            dangerousGoodsId: service.dangerous_goods_id,
            nemWeight: {
              unit: service.nem_weight_unit,
              value: service.nem_weight,
            },
            netWeight: {
              unit: service.net_weight_unit,
              value: service.net_weight,
            },
            bruttoWeight: {
              unit: service.brutto_weight_unit,
              value: service.brutto_weight,
            },
            englishTechnicalDesignation: service.english_technical_designation,
            danishTechnicalDesignation: service.danish_technical_designation,
            iataAutorization: service.iata_autorization,
            flashPoint: service.flash_point,
            segregationGroup: service.segregation_group,
            ems: service.ems,
            notAllInOneQty: service.qty,
            notAllInOneOuterPackaging: service.packing_type,
            innerPackaging: service.inner_packaging,
            innerPackagingQty: service.inner_packaging_qty,
            packingInstruction: service.packing_instruction,
            isEnvironmentalHazard: service.is_environmental_hazard,
            isMarinePollutant: service.is_marine_pollutant,
            isLimitedQuantity: service.is_limited_quantity,
            isExceptedQuantity: service.is_excepted_quantity,
          });
        });

      //Set packages contents to array
      const packageContentArray = [];
      if (pack.hasOwnProperty('content')) {
        const contents = pack.content;

        contents.forEach((cnnt) => {
          packageContentArray.push({
            qty: cnnt.quantity,
            description: cnnt.description,
            unitWeight: {
              value: cnnt.unit_weight,
              unit: cnnt.unit_weight_unit,
            },
            unitValue: {
              value: cnnt.unit_value,
              unit: cnnt.unit_value_currency,
            },
            hsCode: cnnt.hs_code,
            origin: cnnt.origin_country_id,
          });
        });
      }

      if (parseInt(pack.goods_type) === 1) {
        const parcel = {
          colli: payload.packages.filter((packLoop) => packLoop.group == pack.group).length,
          goodsTypeName: 'Parcel',
          goodsType: pack.goods_type,
          parcelType: pack.package_id, // proveri
          description: pack.description,
          packagingName: pack.packaging_name,
          colliWeight: {
            value: pack.weight,
            unit: 'kg',
          },
          dimensions: {
            width: {
              value: pack.width,
              disabled: false,
            },
            height: {
              value: pack.height,
              disabled: false,
            },
            length: {
              value: pack.length,
              disabled: false,
            },
            dimensionsType: 'cm',
          },
          isTemperature: pack.has_temperature,
          minTemperature: pack.min_temp,
          maxTemperature: pack.max_temp,
          isDgToggleActive: dangerousService.length > 0,
          packingTypeOption: dangerousService.length > 0 ? dangerousService[0].packing_type_option : '',
          isOverpack: dangerousService.length > 0 ? dangerousService[0].is_overpack : 0,
          allPackedInOne: dangerousService.length > 0 ? dangerousService[0].all_packed_in_one : 2, //Not all packed in one  = 2
          iataLimitations: dangerousService.length > 0 ? dangerousService[0].iata_limitations : '',
          iataRadioactive: dangerousService.length > 0 ? dangerousService[0].iata_radioactive : '',
          iataAdditionalInfo: dangerousService.length > 0 ? dangerousService[0].iata_additional_info : '',
          qty: dangerousService.length > 0 ? dangerousService[0].qty : '',
          Q: dangerousService.length > 0 ? dangerousService[0].Q : '',
          packingType: dangerousService.length > 0 ? dangerousService[0].packing_type : '',
          dangerousGoodsServices: dangerousGoodsArray,
          content: packageContentArray
         };

        shipPackages.push(parcel);
      }
      else if (parseInt(pack.goods_type) === 2) {
        const document = {
          goodsTypeName: 'Document',
          goodsType: pack.goods_type,
          colli: payload.packages.filter((packLoop) => packLoop.group == pack.group).length,
          parcelType: pack.package_id,
          packagingName: pack.packaging_name,
          colliWeight: {
            value: pack.weight,
            unit: 'kg',
          },
          dimensions: {
            width: {
              value: pack.width,
              disabled: false,
            },
            height: {
              value: pack.height,
              disabled: false,
            },
            length: {
              value: pack.length,
              disabled: false,
            },
            dimensionsType: 'cm',
          },
        };

        shipPackages.push(document);
      }
      else if (parseInt(pack.goods_type) === 3) {
        const pallet = {
          goodsTypeName: 'Pallet',
          goodsType: pack.goods_type,
          colli: payload.packages.filter((packLoop) => packLoop.group == pack.group).length,
          description: pack.description,
          palleteType: pack.pallet_type,
          colliWeight: {
            value: pack.weight,
            unit: 'kg',
          },
          dimensions: {
            width: {
              value: pack.width,
              disabled: false,
            },
            height: {
              value: pack.height,
              disabled: false,
            },
            length: {
              value: pack.length,
              disabled: false,
            },
            dimensionsType: 'cm',
          },
          isTemperature: pack.has_temperature,
          minTemperature: pack.min_temp,
          maxTemperature: pack.max_temp,
          isDgToggleActive: dangerousService.length > 0 ? true : false,
          packingTypeOption: dangerousService.length > 0 ? dangerousService[0].packing_type_option : '',
          isOverpack: dangerousService.length > 0 ? dangerousService[0].is_overpack : false,
          allPackedInOne: dangerousService.length > 0 ? dangerousService[0].all_packed_in_one : 2, //Not all packed in one  = 2
          iataLimitations: dangerousService.length > 0 ? dangerousService[0].iata_limitations : '',
          iataRadioactive: dangerousService.length > 0 ? dangerousService[0].iata_radioactive : '',
          iataAdditionalInfo: dangerousService.length > 0 ? dangerousService[0].iata_additional_info : '',
          qty: dangerousService.length > 0 ? dangerousService[0].qty : '',
          Q: dangerousService.length > 0 ? dangerousService[0].Q : '',
          packingType: dangerousService.length > 0 ? dangerousService[0].packing_type : '',
          pallet_stackable_type: pack.pallet_stackable_type,
          palletSpace: pack.pallet_space,
          dangerousGoodsServices: dangerousGoodsArray,
          content: packageContentArray
        };

        shipPackages.push(pallet);
      }
      else if (parseInt(pack.goods_type) === 4) {
        const load = {
          goodsTypeName: 'Load',
          goodsType: pack.goods_type,
          colli: payload.packages.filter((packLoop) => packLoop.group == pack.group).length,
          parcelType: pack.package_id,
          description: pack.description,
          colliWeight: {
            value: pack.weight,
            unit: 'kg',
          },
          //For load, we always want to show dimensions in meters
          //Backend by default transform dimensions to cm, so we need to revert them to meters here
          dimensions: {
            width: {
              value: (pack.width / 100).toFixed(2),
              disabled: false,
            },
            height: {
              value: (pack.height / 100).toFixed(2),
              disabled: false,
            },
            length: {
              value: (pack.length / 100).toFixed(2),
              disabled: false,
            },
            dimensionsType: 'm',
          },
          cubicMeter: pack.cubic_meter,
          loadMeter: pack.load_meter,
          isTemperature: pack.has_temperature,
          minTemperature: pack.min_temp,
          maxTemperature: pack.max_temp,
          isDgToggleActive: dangerousService.length > 0 ? true : false,
          packingTypeOption: dangerousService.length > 0 ? dangerousService[0].packing_type_option : '',
          isOverpack: dangerousService.length > 0 ? dangerousService[0].is_overpack : false,
          allPackedInOne: dangerousService.length > 0 ? dangerousService[0].all_packed_in_one : 2, //Not all packed in one  = 2
          iataLimitations: dangerousService.length > 0 ? dangerousService[0].iata_limitations : '',
          iataRadioactive: dangerousService.length > 0 ? dangerousService[0].iata_radioactive : '',
          iataAdditionalInfo: dangerousService.length > 0 ? dangerousService[0].iata_additional_info : '',
          qty: dangerousService.length > 0 ? dangerousService[0].qty : '',
          Q: dangerousService.length > 0 ? dangerousService[0].Q : '',
          packingType: dangerousService.length > 0 ? dangerousService[0].packing_type : '',
          dangerousGoodsServices: dangerousGoodsArray,
          content: packageContentArray //nesto se ovde desava..
        };

        shipPackages.push(load);
      }

      groupList.push(pack.group)
    })

    // GOODS TYPE
    state.shipmentCompareTemplate.activeGoodsTypes = payload.goods_type;
    state.shipmentCompareTemplate.storeShipmentPackages = shipPackages;

    // PAYMENT -CUSTOMES DATA
    state.shipmentCompareTemplate.customsData.goods_incoterm = payload.goods_incoterm;
    state.shipmentCompareTemplate.customsData.duty_paid_by = payload.duty_paid_by;
    state.shipmentCompareTemplate.customsData.duty_payer_account_no = payload.duty_payer_account_no;
    state.shipmentCompareTemplate.customsData.freight_paid_by = payload.freight_paid_by;
    state.shipmentCompareTemplate.customsData.freight_payer_account_no = payload.freight_payer_account_no;
    state.shipmentCompareTemplate.customsData.freight_payer_id = payload.freight_payer_id;
    // customsData: {
    //   customsAddress: {
    //     address_1: '',
    //     address_2: '',
    //     country_id: '',
    //     post_code: '',
    //     city: '',
    //     state: '',
    //   },
    //   customsAddressData:{
    //     company: '',
    //     attention: '',
    //     email: '',
    //     reference: '',
    //     phone: {
    //       number: '',
    //       country: '',
    //     },
    //   },
    // },
    // TAGS
    state.shipmentCompareTemplate.custom_tag_json = payload.custom_tags;

    // SERVICES
    state.shipmentCompareTemplate.apiFeeIds = payload.fee_wrapper_ids;
    state.shipmentCompareTemplate.apiActiveServices = payload.active_services.length > 0 ? payload.active_services_view : null;
    state.shipmentCompareTemplate.selectedProduct = payload.shipping_product_id;
    state.shipmentCompareTemplate.additionalServicesData = payload.active_services_view;
    state.shipmentCompareTemplate.pickupTimeFrom = payload.pickup_time_from ? payload.pickup_time_from : '';
    state.shipmentCompareTemplate.pickupTimeUntil = payload.pickup_time_until ? payload.pickup_time_until : '';
    state.shipmentCompareTemplate.pickupDriverNote = payload.pickup_driver_note ? payload.pickup_driver_note : '';
    state.shipmentCompareTemplate.droppointNo = payload.droppoint_no ? payload.droppoint_no : '';
  },
  [types.CLEAR_EDITING_SHIPMENT]: (state) => {
    state.shipmentEditMode = false;
    //Reset editing shipment state if is set
    if (state.cleanShipmentCompareTemplate) {
      state.shipmentCompareTemplate = _.cloneDeep(state.cleanShipmentCompareTemplate)
    }
  },
};
